'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function callMeNowService($http, callMeNowConstants) {
    var vm = this;

    vm.callMeNow = function (phoneNumber, pageUrl, label, onderwerp) {
        return $http.post(callMeNowConstants.BELMETERUG_URL, {
            CommunicatieParameters: {
                Label: label,
                Onderwerp: onderwerp
            },
            ContactParameters: {
                Telefoonnummer: phoneNumber,
                IndicatieBevestigingViaEmail: false,
                Vraag: '',
                Url: pageUrl,
                Medium: 'D'
            }
        }).then(function (response) {
            if (response.status === 204) {
                return { callMeNow: 'Bel mij verzoek is verzonden', error: false };
            } else {
                return { callMeNow: 'Er is iets misgegaan, probeer het opnieuw', error: true };
            }
        }).catch(function () {
            return { callMeNow: 'Er is iets misgegaan, probeer het opnieuw', error: true };
        });
    };
}

callMeNowService.$inject = ['$http', 'callMeNowConstants'];

exports.default = callMeNowService;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/call-me-now/call-me-now.service.js
// module id = 850
// module chunks = 0